import { render, staticRenderFns } from "./PtspTerminals.vue?vue&type=template&id=3b554e87&scoped=true"
import script from "./PtspTerminals.vue?vue&type=script&lang=js"
export * from "./PtspTerminals.vue?vue&type=script&lang=js"
import style0 from "./PtspTerminals.vue?vue&type=style&index=0&id=3b554e87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b554e87",
  null
  
)

export default component.exports